export default __webpack_public_path__ + "static/media/onboardingLogo.a2c8e6e8.svg";